// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.deliveryterms.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/deliveryterms/deliveryterm/deliveryterm.tpl.html',
            controller: 'DeliveryTermController as vm'
        }},
        resolve: {
            deliveryterm: function() { return {}; },
            languages: languagesResolver,
            isNewDeliveryTerm: function() {return true;}
        }
    });

    $stateProvider.state('base.deliveryterms.deliveryterm', {
        url:'/{deliverytermId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/deliveryterms/deliveryterm/deliveryterm.tpl.html',
            controller: 'DeliveryTermController as vm'
        }},
        resolve: {
            deliveryterm: deliverytermResolver,
            languages: languagesResolver,
            isNewDeliveryTerm: function() {return false;}
        }
    });

}

// @ngInject
function deliverytermResolver($stateParams, DeliveryTermsApiService) {
    return DeliveryTermsApiService.getDeliveryTerm($stateParams.deliverytermId);
}

// @ngInject
function languagesResolver($stateParams, DeliveryTermsApiService) {
    return DeliveryTermsApiService.getLanguages();
}

// @ngInject
function DeliveryTermController($state, deliveryterm, loadSpinnerService, DeliveryTermsApiService, ToasterService, confirmationDialogService, $translate, isNewDeliveryTerm, languages) {
    var vm = this;

    var deliverytermCopy = {};

    vm.deliveryterm = deliveryterm;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveDeliveryTerm = saveDeliveryTerm;
    vm.deleteDeliveryTerm = deleteDeliveryTerm;

    vm.isNewDeliveryTerm = isNewDeliveryTerm;
    vm.isEditing = vm.isNewDeliveryTerm;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactDeliveryTermView') !== 'false';
    vm.reactDeliveryTermId = isNewDeliveryTerm ? null : (deliveryterm && deliveryterm.id != null ? deliveryterm.id : null);

    vm.isDeliveryTermCodeValid = isDeliveryTermCodeValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.languages = languages;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewDeliveryTerm) {
            vm.deliveryterm = {};
        }

        appendLocalizations(vm.deliveryterm, vm.languages);

    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        deliverytermCopy = angular.copy(vm.deliveryterm);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.deliveryterm = deliverytermCopy;
        vm.isEditing = false;
    }

    function saveDeliveryTerm() {
        if (vm.isNewDeliveryTerm) {
            saveNewDeliveryTerm();
        } else {
            updateDeliveryTerm();
        }
    }

    function saveNewDeliveryTerm() {
        loadSpinnerService.start('mainSpinner');
        DeliveryTermsApiService.createDeliveryTerm(vm.deliveryterm).then(function(response) {
            vm.deliveryterm = response;
            prepareData();
            vm.isNewDeliveryTerm = false;
            vm.isEditing = false;
            $state.go('base.deliveryterms.deliveryterm', {deliverytermId: vm.deliveryterm.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateDeliveryTerm() {
        loadSpinnerService.start('mainSpinner');

        DeliveryTermsApiService.updateDeliveryTerm(vm.deliveryterm).then(function(response) {
            vm.deliveryterm = response;
            prepareData();
            vm.isNewDeliveryTerm = false;
            vm.isEditing = false;
            $state.go('base.deliveryterms.deliveryterm', {deliverytermId: vm.deliveryterm.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteDeliveryTerm() {
        confirmationDialogService
            .showDialog($translate.instant('deliveryterm.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    DeliveryTermsApiService.deleteDeliveryTerm(vm.deliveryterm.id).then(function(response) {
                        vm.deliveryterm = response;
                        prepareData();
                        vm.isNewDeliveryTerm = false;
                        vm.isEditing = false;
                        $state.go('base.deliveryterms');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(deliveryterm) {
        deliveryterm.showEditForm = !deliveryterm.showEditForm;
    }

    function prepareData() {
        if (vm.deliveryterm === undefined) {
            return;
        }

        vm.deliverytermCopy = angular.copy(vm.deliveryterm);
    }

    function isAllInformationValid() {
        return isDeliveryTermCodeValid();
    }

    function isDeliveryTermCodeValid() {
        if (!vm.deliveryterm.code) { return false; }
        if (vm.deliveryterm.code.length > 20) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('deliveryterms.deliveryterm', [])
    .config(stateConfig)
    .controller('DeliveryTermController', DeliveryTermController);
